import React from 'react';
import classnames from 'classnames';
import CustomButton from 'components/shared/CustomButton';
import dictData from 'dictionary';
import SmallArrow from 'images/icons/SmallArrow';

interface IProps {
  title: string;
  description: string;
  className?: string;
  subtitle?: string;
  ctaTo?: string;
  ctaHref?: string;
  ctaButtonText?: string;
  linkTo?: string;
  linkHref?: string;
  linkButtonText?: string;
  secondaryButtonStyle?: boolean;
}

const HomeSectionHeader: React.FC<IProps> = ({
  title,
  description,
  subtitle = '',
  secondaryButtonStyle = false,
  ctaTo = '',
  ctaHref = undefined,
  ctaButtonText = '',
  linkTo = '',
  linkHref = undefined,
  linkButtonText = dictData.buttonText.readMore,
  className = ''
}) => {
  const renderCtaButton = (ctaTo || ctaHref) && !(ctaTo && ctaHref);
  const renderSecondaryButton = (linkTo || linkHref) && !(linkTo && linkHref);
  return (
    <div className={classnames('home-section-header', className)}>
      {subtitle && <span>{subtitle}</span>}
      <h2>{title}</h2>
      <p>{description}</p>
      <div className="home-section-btn-wrapper">
        {renderCtaButton && (
          <CustomButton
            className="home-section-cta"
            text={ctaButtonText}
            primary={!secondaryButtonStyle}
            secondary={secondaryButtonStyle}
            to={ctaTo}
            href={ctaHref}
          />
        )}
        {renderSecondaryButton && (
          <CustomButton
            to={linkTo}
            href={linkHref}
            text={linkButtonText}
            link
            icon={<SmallArrow />}
            iconPlacement="right"
            className="home-section-link"
          />
        )}
      </div>
    </div>
  );
};

export default HomeSectionHeader;
